<script setup lang="ts">
import MainSidebar from "@/components/Sidebar/MainSidebar.vue";
</script>

<template>
  <div class="w-full h-screen flex bg-[#F1F0EE] font-sans">
    <div class="hidden md:flex h-[calc(100%-2px)] m-0">
      <MainSidebar />
    </div>
    <div class="w-full h-full flex flex-col">
      <slot />
    </div>
  </div>
</template>
